export const isInIframe = () => {
  return (
    typeof window !== "undefined" &&
    window.parent !== window.self &&
    window.self !== window.parent
  )
}
